import React from 'react';
import { Container, Spinner } from 'reactstrap';
import classes from './Loading.module.css';

const Loading = () => {
    return(
        <>
        <Container className={classes.spinnerContainer}>
            <Spinner className={classes.spinner} />
        </Container>
        <div className={classes.overlay}></div>
        </>
    )
}
export default Loading;